import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import { Form, Row, Col, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty, map } from 'lodash';

import { GEOJSON_GEOMETRIES, POINT_TYPES } from '../../../api/Styles/Styles';
import {
  getIconClass,
  getPointSize,
  getSVGCategory,
  getSVGUrl,
  isScaledSymbology
} from '../../../api/Styles/style-operations';

class PointFields extends Component {
  state = {
    svgCategory: getSVGCategory(this.props.style),
    svgList: []
  };

  async componentDidMount() {
    const { svgCategory } = this.state;
    if (!isEmpty(svgCategory)) {
      this.getSVGList(svgCategory.url);
    }
  }

  handleCategoryChange = async event => {
    const { svgCategoryList } = this.props;
    const newCategoryName = event.target.value.trim();
    svgCategoryList.forEach(category => {
      if (newCategoryName === category.name) {
        this.setState({ svgCategory: { name: category.name, url: category.url } });
        this.getSVGList(category.url);
      }
    });
  };

  getSVGList = async svgCategoryURL => {
    try {
      const response = await fetch(
        'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/list_files_folders',
        {
          method: 'POST',
          body: JSON.stringify({
            path: svgCategoryURL,
            beyond_this_folder: null,
            only_folders: null,
            only_files: null,
            filter_type_file: null
          }),
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors',
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        }
      );
      const answer = await response.json();
      this.setState({ svgList: answer.data });
    } catch (error) {
      Bert.alert('SVG list of category selected not found', 'warning');
    }
  };

  render() {
    const { svgCategory, svgList } = this.state;

    const {
      geojsonGeometry,
      style,
      hasTolerance,
      pointType,
      changePointType,
      svgCategoryList
    } = this.props;

    const iconClass = getIconClass(style);
    const defaultValue = isEmpty(iconClass) ? 'map-marker' : iconClass;
    const sizeName = hasTolerance || pointType === POINT_TYPES.CIRCLEMARKER ? 'Radius' : 'Size';
    if (geojsonGeometry === GEOJSON_GEOMETRIES.POINT) {
      return (
        <>
          <Row>
            <Form.Group as={Col} xs={12}>
              <Form.Check
                name="scaledSymbology"
                label="Scaled Symbology"
                defaultChecked={isScaledSymbology(style)}
              />
            </Form.Group>
            {!hasTolerance && (
              <Col xs={12} md={6}>
                <Form.Group as={Row}>
                  <Form.Label column xs={6}>
                    Point Type
                  </Form.Label>
                  <Col xs={6}>
                    <Form.Control
                      as="select"
                      name="pointType"
                      value={pointType}
                      onChange={changePointType}
                    >
                      <option value="">-</option>
                      {map(POINT_TYPES.properties, ({ name, humanValue, value }) => (
                        <option value={value} key={name}>
                          {humanValue}
                        </option>
                      ))}
                    </Form.Control>
                  </Col>
                </Form.Group>
              </Col>
            )}
            <Col xs={12} md={!hasTolerance ? 6 : 12}>
              <Form.Group as={Row}>
                <Form.Label column xs={6}>
                  {sizeName}
                </Form.Label>
                <Col xs={6}>
                  <Form.Control
                    type="number"
                    name="pointSize"
                    defaultValue={getPointSize(style)}
                    min={0}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          {pointType === POINT_TYPES.ICON && (
            <Form.Group>
              <Form.Label>Font Awesome Icon Class</Form.Label>
              <InputGroup>
                <Form.Control
                  type="text"
                  name="iconClass"
                  defaultValue={defaultValue}
                  placeholder="map-marker"
                />
                <InputGroup.Append>
                  <InputGroup.Text
                    onClick={() => {
                      window.open('https://fontawesome.com/search?o=r&m=free', '_blank');
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    Más información
                  </InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <Form.Text className="text-muted">
                Example: <mark>map-marker</mark> returns <FontAwesomeIcon icon="map-marker" />
              </Form.Text>
            </Form.Group>
          )}
          {pointType === POINT_TYPES.MARKER && (
            <Row>
              <Col xs={12} md={!isEmpty(svgList) ? 6 : 12}>
                <Form.Group>
                  <Form.Label>SVG Category</Form.Label>
                  <Form.Control
                    as="select"
                    name="svgCategory"
                    value={svgCategory.name}
                    onChange={this.handleCategoryChange}
                  >
                    <option value="">-</option>
                    {map(svgCategoryList, ({ name }) => (
                      <option value={name.trim()} key={name.trim()}>
                        {name.trim()}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              {!isEmpty(svgList) && (
                <Col xs={12} md={6}>
                  <Form.Group>
                    <Form.Label>SVG To Show</Form.Label>
                    <Form.Control as="select" name="svgUrl" defaultValue={getSVGUrl(style)}>
                      <option value="">-</option>
                      {map(svgList, ({ url, name }) => (
                        <option value={url} key={url}>
                          {/* <img
                            src={url}
                            alt={name}
                            // style={{ marginRight: '5px', width: '20px', height: '20px' }}
                          /> */}
                          {name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              )}
            </Row>
          )}
        </>
      );
    }
    return '';
  }
}

PointFields.propTypes = {
  geojsonGeometry: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  hasTolerance: PropTypes.bool.isRequired,
  pointType: PropTypes.string.isRequired,
  changePointType: PropTypes.func.isRequired,
  svgCategoryList: PropTypes.array.isRequired
};

export default PointFields;
